<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<main class="main-site-wrap wrapper">
    <app-header></app-header>
    <div class="site-content-wrap position-relative">
        <app-sidebar></app-sidebar>

        <!--start page wrapper -->
        <div class="page-wrapper">

            <!-- Start type of Albums -->
            <div class="page-content">

                <section class="inner-section-wrap" *ngIf="showView && currentUrl=='/album-video-list'">
                    <div class="page-breadcrumb mb-1 pb-3">
                        <div class="row align-items-center">
                            <div class="col-12 col-sm-8">
                                <div class="d-flex align-items-center justify-content-start">
                                    <a routerLink="/albums" class="btn ic-fill-btn">
                                        <i class="fa-solid fa-arrow-left"></i>
                                    </a>
                                    <h5 class="breadcrumb-title m-0 px-3 text-capitalize"> {{Program_name}}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3">
                        <div class="col px-sm-2 px-lg-1 pb-4" *ngFor="let item of albumListing">
                            <div class="card dark-bg video-card2 overlapping-card border-radius10">
                                <a href="javascript:void(0)" (click)="redirect(item)" class="d-block">
                                    <div class="card-video2-box imgvid-cover border-radius10">
                                        <img  loading="lazy"  class="max-height-200 border-radius10" [src]="item.thumbnail" />
                                    </div>
                                    <div class="card-content overlapping-card-content p-3">
                                        <div class="video-category pb-3">
                                            <div class="brand-badge p-3 border-radius10 d-inline-block text-capitalize"> {{item.creator_first_name}} {{item.creator_surname}}</div>
                                        </div>
                                        <h6 class="title m-0 white-color py-3 font-w-600"> {{item.name}} </h6>

                                        <div class="card-footer p-0 m-0 border-0">
                                            <div class="row align-items-center">
                                                <div class="col-12">
                                                    <div class="d-flex align-items-center justify-content-end">
                                                        <div class="video-view d-flex align-items-center pe-3">
                                                            <i class="gricon gr_ic_eye brandsecundary-color font-16"></i>
                                                            <span class="ps-1 font-11 white-color"> {{item.view}} </span>
                                                        </div>
                                                        <div class="video-like d-flex align-items-center">
                                                            <i class="gricon gr_ic_heart orange-color font-16"></i>
                                                            <span class="ps-1 font-11 white-color"> {{item.like}}  </span>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="inner-section-wrap" *ngIf="showView && currentUrl!='/album-video-list'">
                    <div class="page-breadcrumb mb-1 pb-3">
                        <div class="row align-items-center">

                            <div class="col-12 col-sm-6">
                                <div class="d-flex align-items-center justify-content-start">
                                    <a routerLink="/programs" class="btn ic-fill-btn">
                                        <i class="fa-solid fa-arrow-left"></i>
                                    </a>
                                    <h3 class="breadcrumb-title m-0 px-3 text-capitalize">
                                        {{Program_name}}
                                        <!-- <span [translate]="'GREATER.PROGRAM_LIST'"> </span> -->
                                    </h3>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 position-relative">
                                <div class="filter-dropdown d-flex align-items-center justify-content-sm-end">
                                    <ul class="mb-0 p-0">

                                        <li class="dropdown dropdown-large filter-dropdown pt-3 pt-sm-0">
                                            <a class="ic-fill-btn d-flex align-items-center nav-link dropdown-toggle dropdown-toggle-nocaret" href="javascript:void(0);" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                <i class="gricon gr_ic_filter"></i>
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-end dark-bg border-radius20">
                                                <div class="row align-items-center py-3 m-0">
                                                    <div class="col-4">
                                                        <a href="javascript:void(0)" (click)="searchKey=0;getRecord('')"> <span [translate]="'GREATER.CANCEL'"> </span> </a>
                                                    </div>
                                                    <div class="col-4 text-center">
                                                        <h6 class="title m-0 white-color"> <span [translate]="'GREATER.FILTER'"> </span> </h6>
                                                    </div>
                                                    <div class="col-4 text-end">
                                                        <a href="javascript:void(0)" (click)="searchKey=0;getRecord('')"> <span [translate]="'GREATER.CLEAR'"> </span> </a>
                                                    </div>
                                                </div>
                                                <div class="p-3">
                                                    <div class="custom-form">
                                                        <div class="custom-checkbox right-select-checkbox mb-2 py-2 px-3 border-radius5 darksecundary-bg">
                                                            <div class="form-check">
                                                                <input class="form-check-input" type="radio" name="filtercheckbox1" id="all" [checked]="searchKey==''" (click)="searchKey=''">
                                                                <label class="form-check-label" for="FilterCheckbox1">All</label>
                                                            </div>
                                                            <div class="form-check" *ngFor="let item of weekarray">
                                                                <input class="form-check-input" type="radio" name="filtercheckbox1" [id]="item" [checked]="searchKey==item" (click)="searchKey=item">
                                                                <label class="form-check-label" for="FilterCheckbox1"> <span [translate]="'GREATER.WEEK'"> </span> {{item}} </label>
                                                            </div>
                                                        </div>
                                                        <div class="pt-5 pb-4 px-3 btn-box text-center">
                                                            <button type="button" class="btn gradient1-btn custom-btn" (click)="getRecord(searchKey)">Show Results </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Table Block Start -->
                    <div class="table-wrap px-3 py-2 dark-bg border-radius20">
                        <div class="table-responsive table-block">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col"><span [translate]="'GREATER.NO'"> </span>.</th>
                                        <th scope="col"><span [translate]="'GREATER.IMAGE'"> </span></th>

                                        <th scope="col">
                                            <span [translate]="'GREATER.TITLE'"> </span>
                                        </th>
                                        <th scope="col">
                                            <span [translate]="'GREATER.WEEK'"> </span>
                                        </th>
                                        <th scope="col">
                                            <span [translate]="'GREATER.DAY'"> </span>
                                        </th>
                                        <!-- <th scope="col">Length</th> -->
                                        <th scope="col">
                                            <span [translate]="'GREATER.LIKES'"> </span>
                                        </th>
                                        <!-- <th scope="col">
                                        <span [translate]="'GREATER.CREATED_AT'"> </span>
                                    </th> -->
                                        <th scope="col"><span [translate]="'GREATER.VIEWS'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.ACTIONS'"> </span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of albumListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                        <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                        <td scope="row">
                                            <img  loading="lazy"  class="video-img" [src]="item.thumbnail" style="height:100px;width:150px ;object-fit:contain ; background-color: #1a1d1f">
                                        </td>
                                        <td>{{item.name}}</td>
                                        <td>{{item.week_id}}</td>
                                        <td>{{item.day_id}}</td>
                                        <!-- <td>32 mins</td> -->
                                        <td>{{item.like}}</td>
                                        <!-- <td>{{service.convertDate(item.createdAt)}}</td> -->
                                        <td>{{item.view}}</td>
                                        <td class="action-btn-box">
                                            <a (click)="redirect(item)" class="btn action-btn ic-fill-btn"><i class="gricon gr_ic_eye"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="pagination-block pt-4">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="p=$event" class="text-center" *ngIf="albumListing.length > 0"></pagination-controls>
                            </div>

                        </div>
                    </div>

                </section>
            </div>

        </div>

    </div>
    <app-footer></app-footer>
</main>